export function stripLocalePrefix(pathname: string): string {
  return pathname.replace(/^\/(vi|en)(?=\/|$)/, "") || "/"
}

/**
 * position = segment đầu tiên của pathname (đã bỏ prefix /vi|/en), dùng làm quy ước
 * chung cho cả `faq_categories.position[]` và `faqs.meta[].page` khi cấu hình ở CMS.
 */
export function resolveFaqPosition(pathname: string, override?: string): string {
  if (override) return override

  const stripped = stripLocalePrefix(pathname)
  const match = stripped.match(/^\/([^/]+)/)

  return match ? `/${match[1]}` : "/"
}
